<template>
  <div class="shadow-navigation w-full rounded-t-10 flex flex-row justify-between items-start relative bg-[rgb(var(--color-menu-background))]">
    <div class="w-14 h-14 ml-2 flex-shrink-0 flex justify-center items-center" @click="$router.push('/')">
      <img :src="logo" class="h-6" />
    </div>

    <BottomNavigationItem
      v-for="(item, index) in navigationItems"
      :text="$t(item.label)"
      :key="index"
      class="sm:mx-2"
      :icon="item.icon"
      :selected="isNavItemSelected(item)"
      @click="selectNavItem(item)"
    />
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import BottomNavigationItem from './BottomNavigationItem';
import DeleteModal from '../components/modals/DeleteModal.vue';

export default {
  name: 'BottomNavigation',
  model: {
    prop: 'value',
    event: 'input',
  },
  components: { BottomNavigationItem },
  props: {
    value: Boolean,
    navItems: {
      type: Array,
      default: () => [],
    },
    logo: String,
  },
  computed: {
    ...mapState(['user', 'features', 'theme']),
    navigationItems() {
      return this.navItems.filter((item) => {
        if (item.restrictTo) {
          return this.features.includes(item.restrictTo);
        }
        return true;
      });
    },
  },
  methods: {
    ...mapActions(['logout']),
    selectNavItem(item) {
      if (item.to === '/logout') {
        this.$showModal(DeleteModal, {
          title: this.$t('logout'),
          subtitle: this.$t('confirm_logout_message'),
          confirm: this.$t('logout'),
          onConfirm: () => {
            this.logout({ clearIdb: true });
          },
        });
      } else {
        this.$router.push(item.to);
      }
    },
    isNavItemSelected(item) {
      if (item.to.startsWith('/admin')) {
        return this.$route.path.startsWith('/admin') || this.$route.path.startsWith('/iam');
      }
      if (item.to.startsWith('/user')) {
        return this.$route.path.startsWith('/user');
      }
      if (item.to.startsWith('/project')) {
        return this.$route.path.startsWith('/project');
      }
      if (item.to.startsWith('/collection')) {
        return this.$route.path.startsWith('/collection');
      }
      return this.$route.path === item.to;
    },
  },
};
</script>
